import { RadioGroup, RadioGroupProps } from '@/shadcn-ui/radio-group';
import PlanRadioButton, { PlanRadioButtonCopy } from './plan-radio-button';

interface PlanRadioGroupProps extends RadioGroupProps {
  plans: PlanRadioButtonCopy[];
  name: string;
  selectedPlanId?: string;
  error?: string;
  onClickDelegate?: (e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
  planRadioButtonClassName?: string;
}

export default function PlanRadioGroup({
  plans,
  selectedPlanId,
  name,
  disabled,
  error,
  onClickDelegate,
  planRadioButtonClassName,
  ...props
}: PlanRadioGroupProps) {
  return (
    <>
      <RadioGroup
        name={name}
        defaultValue={selectedPlanId ?? ''}
        className="gap-[8px]"
        disabled={disabled}
        {...props}
      >
        {plans.map((plan) => {
          const planDisabled = disabled || plan.disabled;

          return (
            <PlanRadioButton
              key={plan.id}
              plan={{
                ...plan,
                disabled: planDisabled,
              }}
              selected={selectedPlanId === String(plan.id)}
              onClickDelegate={onClickDelegate}
              className={planRadioButtonClassName}
            />
          );
        })}
      </RadioGroup>

      {error ? (
        <p id="plan-error-text" className="body3 mt-[4px] text-flexcar-red40">
          {error}
        </p>
      ) : null}
    </>
  );
}
